import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import PageRouter from "./PageRouter";
import PopupTargetController from "./PopupTargetController";
import SuccessMessage from "../classes/SuccessMessage";
import SuccessMessageView1 from "./SuccessMessageView1";
import InfoMessage from "../classes/InfoMessage";
import Popup from "./Popup";
import EventBus from "../utils/EventBus";
import PageNavigator from "../classes/PageNavigator";
import Timer from "../utils/Timer";
import AdminHeader from "./AdminHeader";
import Admin from "../models/Admin";
import FailureMessageView from "./FailureMessageView";
import AdminSideMenuView from "./AdminSideMenuView";
import Duration from "../core/Duration";
import FailureMessage from "../classes/FailureMessage";
import InfoMessageView from "./InfoMessageView";
import { Subscription } from "rxjs";
import { BuildContext } from "../classes/BuildContext";

export interface AdminHomePageProps extends BaseUIProps {
  key?: string;
  admin: Admin;
}

class _AdminHomePageState extends ObservableComponent<AdminHomePageProps> {
  static defaultProps = { admin: null };
  private _successMessageSubscription: Subscription;
  private _failureMessageSubscription: Subscription;
  private _infoMessageSubscription: Subscription;
  message: string = "";
  successMessagePopup: Popup;
  failureMessagePopup: Popup;
  infoMessageViewPopup: Popup;
  static contextType = BuildContext;
  context: React.ContextType<typeof BuildContext>;
  public id3434PopupTargetController: PopupTargetController =
    new PopupTargetController();
  public constructor(props: AdminHomePageProps) {
    super(props);

    this.initState();
  }
  public get admin(): Admin {
    return this.props.admin;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;

    this.onInit();

    this._successMessageSubscription = EventBus.get()
      .on<SuccessMessage>(SuccessMessage)
      .subscribe((value) => this.onSuccessMessage(value));

    this._failureMessageSubscription = EventBus.get()
      .on<FailureMessage>(FailureMessage)
      .subscribe((value) => this.onFailureMessage(value));

    this._infoMessageSubscription = EventBus.get()
      .on<InfoMessage>(InfoMessage)
      .subscribe((value) => this.onInfoMessage(value));
  }
  public initListeners(): void {
    this.updateSyncProperty("admin", this.props.admin);

    this.on(["admin"], this.rebuild);
  }
  public componentDidUpdate(prevProps: AdminHomePageProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.admin !== this.props.admin) {
      this.updateObservable("admin", prevProps.admin, this.props.admin);

      this.fire("admin", this);
    }
  }
  public setMessage(val: string): void {
    let isValChanged: boolean = this.message !== val;

    if (!isValChanged) {
      return;
    }

    this.message = val;

    this.fire("message", this);
  }
  public render(): ReactNode {
    let cStyle = this.context.theme;

    return ui.Column({
      crossAxisAlignment: ui.CrossAxisAlignment.start,
      mainAxisAlignment: ui.MainAxisAlignment.start,
      children: [
        ui.Row({
          crossAxisAlignment: ui.CrossAxisAlignment.start,
          mainAxisAlignment: ui.MainAxisAlignment.start,
          children: [
            ui.Container({
              width: 330,
              child: AdminSideMenuView({
                admin: this.admin,
                onMenuChanged: (menu) => {
                  this.onMenuClicked(menu);
                },
              }),
              key: "0",
              className: "x628 hc vc v",
            }),
            ui.Column({
              mainAxisAlignment: ui.MainAxisAlignment.start,
              crossAxisAlignment: ui.CrossAxisAlignment.start,
              children: [
                AdminHeader({
                  admin: this.admin,
                  className: "x2af hc h",
                  key: "0",
                }),
                ui.Column({
                  crossAxisAlignment: ui.CrossAxisAlignment.start,
                  mainAxisAlignment: ui.MainAxisAlignment.start,
                  children: [
                    ui.Container({
                      child: PageRouter({
                        target: "main",
                        className: "xb20 hc vc h v",
                      }),
                      d3eRef: this.id3434PopupTargetController.handleRef,
                      className: "x4f hc vc h v",
                      key: "0",
                    }),
                  ],
                  className: "xe1a hc vc h v",
                  key: "1",
                }),
              ],
              className: "xdc6 hc vc h v",
              key: "1",
            }),
          ],
          className: "x08 hc vc h v",
          key: "0",
        }),
      ],
      className: ui.join(this.props.className, "AdminHomePage x5f hc vc"),
      ...copyBaseUIProps(this.props),
    });
  }
  public onInit = (): void => {
    new Timer(new Duration({ seconds: 1 }), () => {
      this.navigator.pushAdminDashboardPage2({
        admin: this.admin,
        target: "main",
        replace: true,
      });
    });
  };
  public onInfoMessage = (msg: InfoMessage): void => {
    this.setMessage(msg.message !== null ? msg.message : "No Records Found");

    this.showInfoMessageView({ autoClose: true, model: false });

    new Timer(new Duration({ seconds: 5 }), () => {
      this.hideInfoMessageView();
    });
  };
  public onSuccessMessage = (msg: SuccessMessage): void => {
    this.setMessage(msg.message);

    this.showSuccessMessage({ autoClose: true, model: false });

    new Timer(new Duration({ seconds: 5 }), () => {
      this.hideSuccessMessage();
    });
  };
  public onFailureMessage = (msg: FailureMessage): void => {
    this.setMessage(msg.message);

    this.showFailureMessage({ autoClose: true, model: false });

    new Timer(new Duration({ seconds: 5 }), () => {
      this.hideFailureMessage();
    });
  };
  public onCloseMessage = (): void => {
    this.hideFailureMessage();

    this.hideSuccessMessage();
  };
  public onCancelPressed = (): void => {
    this.onCloseMessage();
  };
  public onCancelPressed2 = (): void => {
    this.onCloseMessage();
  };
  public onCancelPressed3 = (): void => {
    this.onCloseMessage();
  };
  public onMenuClicked = (menu: string): void => {
    switch (menu) {
      case "Dashboard": {
        this.navigator.pushAdminDashboardPage2({
          admin: this.admin,
          target: "main",
          replace: false,
        });
        break;
      }

      case "Business Management": {
        this.navigator.pushAdminBusinessManagementPage({
          target: "main",
          replace: false,
        });
        break;
      }

      case "Category Management": {
        this.navigator.pushAdminCategoryManagementPage({
          target: "main",
          replace: false,
        });
        break;
      }

      case "Configuration": {
        this.navigator.pushAdminConfigurationPage({
          target: "main",
          replace: false,
        });
        break;
      }
      default: {
      }
    }
  };
  public dispose(): void {
    this._successMessageSubscription.unsubscribe();

    this._failureMessageSubscription.unsubscribe();

    this._infoMessageSubscription.unsubscribe();

    this.successMessagePopup?.dispose();

    this.failureMessagePopup?.dispose();

    this.infoMessageViewPopup?.dispose();

    super.dispose();
  }
  public showSuccessMessage(
    d3eParams?: Partial<{
      autoClose: boolean;
      model: boolean;
      float: boolean;
      takeFocus: boolean;
    }>
  ): void {
    let autoClose = d3eParams?.autoClose;

    let model = d3eParams?.model;

    let float = d3eParams?.float;

    let takeFocus = d3eParams?.takeFocus;

    this.successMessagePopup?.dispose();

    let target: ui.Rect = this.id3434PopupTargetController.getTarget(
      this.context
    );

    this.successMessagePopup = new Popup({
      autoClose: autoClose,
      model: model,
      float: float,
      takeFocus: takeFocus,
      position: ui.PopUpPosition.Top,
      child: ui.Container({
        height: 50,
        margin: ui.EdgeInsets.fromLTRB(0.0, 90.0, 15.0, 0.0, new Map()),
        child: SuccessMessageView1({
          msg: this.message,
          onClosePressed: () => {
            this.onCancelPressed();
          },
        }),
        className: "x896 hc vc",
      }),
      target: target,
    });

    this.successMessagePopup.showPopup(this.context);
  }
  public showFailureMessage(
    d3eParams?: Partial<{
      autoClose: boolean;
      model: boolean;
      float: boolean;
      takeFocus: boolean;
    }>
  ): void {
    let autoClose = d3eParams?.autoClose;

    let model = d3eParams?.model;

    let float = d3eParams?.float;

    let takeFocus = d3eParams?.takeFocus;

    this.failureMessagePopup?.dispose();

    let target: ui.Rect = this.id3434PopupTargetController.getTarget(
      this.context
    );

    this.failureMessagePopup = new Popup({
      autoClose: autoClose,
      model: model,
      float: float,
      takeFocus: takeFocus,
      position: ui.PopUpPosition.Top,
      child: ui.Container({
        height: 50,
        margin: ui.EdgeInsets.fromLTRB(0.0, 90.0, 15.0, 0.0, new Map()),
        child: FailureMessageView({
          msg: this.message,
          onClosePressed: () => {
            this.onCancelPressed2();
          },
        }),
        className: "x7b hc vc",
      }),
      target: target,
    });

    this.failureMessagePopup.showPopup(this.context);
  }
  public showInfoMessageView(
    d3eParams?: Partial<{
      autoClose: boolean;
      model: boolean;
      float: boolean;
      takeFocus: boolean;
    }>
  ): void {
    let autoClose = d3eParams?.autoClose;

    let model = d3eParams?.model;

    let float = d3eParams?.float;

    let takeFocus = d3eParams?.takeFocus;

    this.infoMessageViewPopup?.dispose();

    let target: ui.Rect = this.id3434PopupTargetController.getTarget(
      this.context
    );

    this.infoMessageViewPopup = new Popup({
      autoClose: autoClose,
      model: model,
      float: float,
      takeFocus: takeFocus,
      position: ui.PopUpPosition.Top,
      child: ui.Container({
        height: 50,
        margin: ui.EdgeInsets.fromLTRB(0.0, 90.0, 15.0, 0.0, new Map()),
        child: InfoMessageView({
          message: this.message,
          onClosePressed: () => {
            this.onCancelPressed3();
          },
        }),
        className: "x01a hc vc",
      }),
      target: target,
    });

    this.infoMessageViewPopup.showPopup(this.context);
  }
  public hideSuccessMessage(): void {
    this.successMessagePopup?.dispose();
  }
  public hideFailureMessage(): void {
    this.failureMessagePopup?.dispose();
  }
  public hideInfoMessageView(): void {
    this.infoMessageViewPopup?.dispose();
  }
  public get navigator(): PageNavigator {
    return PageNavigator.of(this.context);
  }
}
export default function AdminHomePage(props: AdminHomePageProps) {
  return React.createElement(_AdminHomePageState, {
    ..._AdminHomePageState.defaultProps,
    ...props,
  });
}
